import { render, staticRenderFns } from "./teamInfo.vue?vue&type=template&id=85e73ea8&scoped=true"
import script from "./teamInfo.vue?vue&type=script&lang=js"
export * from "./teamInfo.vue?vue&type=script&lang=js"
import style0 from "./teamInfo.vue?vue&type=style&index=0&id=85e73ea8&prod&scoped=scoped&lang=scss"
import style1 from "./teamInfo.vue?vue&type=style&index=1&id=85e73ea8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e73ea8",
  null
  
)

export default component.exports